import { FormLabel, Grid, TextField, Typography } from "@mui/material";
import PropTypes from 'prop-types';

const ActividadExperienciaAprendizaje = ({ promptData, setPromptData }) => {
  const handleActividadExperienciaAprendizaje = (event) => {
    const { value } = event.target;

    setPromptData((prevData) => ({
      ...prevData,
      actividad: value,
    }));
  };

  return (
    <Grid xs={12}>
      <Typography
        id="modal-modal-title"
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        Actividad o experiencia de aprendizaje
      </Typography>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Detalla la actividad que esperas que ummIA modifique
      </FormLabel>
      <TextField
        required
        id="contexto"
        placeholder="Detalla la actividad aquí."
        name="contexto"
        fullWidth
        multiline
        rows={5}
        autoComplete="given-name"
        variant="outlined"
        value={promptData.actividad}
        onChange={handleActividadExperienciaAprendizaje}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#336B87",
            "&::placeholder": {
              color: "#336B87",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

ActividadExperienciaAprendizaje.propTypes = {
  promptData: PropTypes.func.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default ActividadExperienciaAprendizaje;
